var consentLinks = {
    en: new URL("https://images.synchronycredit.com/assets/generic/en/eConsent_document.pdf"),
    es: new URL("https://images.synchronycredit.com/assets/generic/es/eConsent_document.pdf"),
};
export default consentLinks;
